var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ResultsPageModalToggle } from '@/components/results-page-modal-toggle.component';
import { HearingAbilityContent } from '@/components/hearing-ability-content.component';
import { Typography } from '@mui/material';
import { useSimpleModal } from 'hx-ui';
import React from 'react';
import { IconPoweredByHearX } from 'hx-assets';
import { useSelector } from 'react-redux';
export function HearingTestResult(_a) {
    var _b = _a.category, textColor = _b.textColor, emphasizedText = _b.emphasizedText;
    var _c = useSimpleModal(_jsx(HearingAbilityContent, {}), {
        modalProps: {
            className: 'max-w-[700px]',
        },
        buttons: _jsx(_Fragment, {})
    }), modal = _c[0], toggleModal = _c[1];
    var score = useSelector(function (state) { return state.dinTest.result.score; });
    var scoreAsWholeNumber = Math.trunc(score !== null && score !== void 0 ? score : 0);
    return (_jsxs("div", __assign({ className: "flex flex-col gap-8 items-center md:pt-12" }, { children: [_jsxs("div", __assign({ className: 'flex flex-col items-center gap-4' }, { children: [_jsx("div", __assign({ className: "flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full", style: {
                            border: "4px solid ".concat(textColor)
                        } }, { children: _jsx(Typography, __assign({ variant: 'h1', className: 'text-3xl md:text-5xl', style: {
                                color: textColor,
                            } }, { children: scoreAsWholeNumber })) })), _jsxs(Typography, __assign({ variant: 'h2', className: "text-center text-xl" }, { children: ["Your results show", ' ', " ", _jsx("br", {}), _jsxs("span", __assign({ style: {
                                    color: textColor,
                                } }, { children: [emphasizedText, "."] }))] }))] })), modal, _jsx(IconPoweredByHearX, { className: "flex w-[160px]" }), _jsx(ResultsPageModalToggle, { className: 'text-dark-text font-bold text-lg underline decoration-dark-text', toggleModal: toggleModal, text: 'What do my results mean?' })] })));
}
